<template>
<div class='waitingCom'>
<div class="pop" id="tip_message">
  <div class="messageWrapper">
      <div class="imgWrapper">
          <img src="../../assets/waiting.gif" class="messageImg"/>
      </div>
      <div class="waitingText">报告显示中，请耐心等待</div>
  </div>
</div>
</div>
</template>
<script>
export default {
  name: 'waiting',
  props: [],
  data() {
    return {
      dialogImgSrc: ''
    }
  },
  created() {
  },
  methods: {
    goBack() {
      this.$emit('dialogGoBack', false)
    }
  }

}
</script>
<style lang='less'>
.waitingCom{
  position: absolute;
.pop{
  position:fixed;
  width:100%;
  height:100%;
  left:0;
  top:0;
  background-color:rgba(0,0,0,.7)
}
.messageWrapper{
 width:5.6rem;
 height:4.5rem;
 background-color: #fff;
 position:absolute;
 left:50%;
 top:50%;
 margin-top: -2rem;
 margin-left:-2.8rem;
 border-radius: 0.2rem;
 z-index: 800;
}

.imgWrapper{
  width:100%;
  height: auto;
  text-align:center;
  margin-top:0.2rem;
}
.messageImg{
  width:3rem;
  height:auto;
}

.waitingText{
    color:#7DA5D1;
    text-align:center;
    font-size:0.3rem;
}
}
</style>



// WEBPACK FOOTER //
// src/components/waiting/waiting.vue